import React, { useState, useEffect } from "react";
import styles from "../styles/TestimonialsSlider.module.css";

const Star = ({ filled }) => (
    <span className={filled ? styles.starFilled : styles.starEmpty}>★</span>
);

export default function TestimonialsSlider() {
    const [testimonials, setTestimonials] = useState([]);
    const [startIndex, setStartIndex] = useState(0);
    const [modalItem, setModalItem] = useState(null);
    const [cardsPerView, setCardsPerView] = useState(4);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") setModalItem(null);
        };
        if (modalItem) document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [modalItem]);

    useEffect(() => {
        fetch(
            "https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Testimonials?filter[status][_eq]=published"
        )
            .then((res) => res.json())
            .then((data) => {
                setTestimonials(data.data || []);
                setStartIndex(0);
            })
            .catch((err) => console.error("Ошибка загрузки отзывов:", err));
    }, []);

    useEffect(() => {
        const updateCardsPerView = () => {
            setCardsPerView(window.innerWidth < 768 ? 1 : 4);
        };
        updateCardsPerView();
        window.addEventListener("resize", updateCardsPerView);
        return () => window.removeEventListener("resize", updateCardsPerView);
    }, []);

    const total = testimonials.length;
    const maxIndex = Math.max(total - cardsPerView, 0);
    const stepPercent = 100 / total;
    const trackWidth = (total / cardsPerView) * 100;

    const handlePrev = () => setStartIndex((i) => Math.max(i - 1, 0));
    const handleNext = () => setStartIndex((i) => Math.min(i + 1, maxIndex));

    if (total === 0) return null;

    const maskAuthor = (fullName) => {
        if (!fullName) return "";
        const parts = fullName.trim().split(" ");
        if (parts.length === 1) return parts[0];
        return `${parts[0]} *****`; // имя + скрытая фамилия
    };


    return (
        <div className={styles.testimonials}>
            <header>
                <h1 className="title-category">
                    Das sagen unsere Schüler –<br /> <span>wir freuen uns schon auf dein Feedback!</span>
                </h1>
                <p>Unsere Schüler:innen wissen am besten, wie’s läuft: Schau dir ihre Erfahrungen an und hol dir einen ersten Eindruck von unserer Fahrschule. Wir sind gespannt auf dein Feedback – vielleicht steht deine Bewertung schon bald hier!</p>
            </header>
            <div className={styles.sliderWrapper}>
                <button
                    onClick={handlePrev}
                    disabled={startIndex === 0}
                    className={styles.arrow}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="var(--orange)"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"></path></svg>
                </button>

                <div className={styles.sliderViewport}>
                    <div
                        className={styles.sliderTrack}
                        style={{
                            transform: `translateX(-${startIndex * stepPercent}%)`,
                            width: `${trackWidth}%`,
                        }}
                    >
                        {testimonials.map((item, idx) => (
                            <div
                                key={item.id || idx}
                                className={styles.card}
                                style={{ width: `${100 / total}%` }}
                                onClick={() => setModalItem(item)}
                            >
                                <div className={styles.cardContent}>
                                    {/* <div className={styles.author}>{item.author}</div> */}
                                    <div className={styles.author}>
                                        {item.hide ? maskAuthor(item.author) : item.author}
                                    </div>


                                    <div className={styles.stars}>
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <Star key={i} filled={i < item.rating} />
                                        ))}
                                    </div>
                                    <div className={styles.text}>“{item.text}”</div>
                                    {item.source && (
                                        <div className={styles.source}>Quelle: {item.source}</div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    onClick={handleNext}
                    disabled={startIndex === maxIndex}
                    className={styles.arrow}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="var(--orange)"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg>
                </button>
            </div>

            {modalItem && (
                <div className={styles.modalOverlay} onClick={() => setModalItem(null)}>
                    <div
                        className={styles.modal}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* <div className={styles.modalAuthor}>{modalItem.author}</div> */}
                        <div className={styles.modalAuthor}>
                            {modalItem.hide ? maskAuthor(modalItem.author) : modalItem.author}
                        </div>
                        <div className={styles.modalStars}>
                            {Array.from({ length: 5 }).map((_, i) => (
                                <Star key={i} filled={i < modalItem.rating} />
                            ))}
                        </div>
                        <div className={styles.modalText}>{modalItem.text}</div>
                        {modalItem.source && (
                            <div className={styles.modalSource}>Quelle: {modalItem.source}</div>
                        )}
                        <button className={styles.modalClose} onClick={() => setModalItem(null)}>
                            ✕
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
